// Note: The first file of a module here, must also register the module

import "./canvass-status-form.component";
import "./canvass-status-list.component";
import "./canvass-status-workflow.component";
import "./explain-canvass-status.component";
import "./delete-canvass-status.component";
import "./migrate-canvass-status.component";
